import Action from 'redux/helpers/createAction'
const name = 'dashboard'

export const getDashboardData = Action(
  name + '/GET_DASHBOARD_DATA',
  (domainId = null, filters = {}) => ({
    domainId,
    filters
  })
)

export const getDashboardDataSuccess = Action(name + '/GET_DASHBOARD_DATA_SUCCESS', payload => ({
  payload
}))

export const getDashboardDomainsSuccess = Action(
  name + '/GET_DASHBOARD_DOMAINS_SUCCESS',
  (domainId, domains) => ({
    domainId,
    domains
  })
)

export const getDashboardDataFailure = Action(name + '/GET_DASHBOARD_DATA_FAILURE', error => ({
  error
}))

export const downloadReport = Action(
  name + '/DOWNLOAD_REPORT',
  (domainId, reportId, dateFrom, dateTo) => ({
    domainId,
    reportId,
    dateFrom,
    dateTo
  })
)
